export default "__VITE_ASSET__CNibj_SB__"